module.exports = __webpack_public_path__ + "static/img/s3.8370327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/samSet/s3.png
// module id = rFiU
// module chunks = 0